var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.showCeiAlert
        ? _c(
            "BaseAlert",
            {
              staticClass: "my-2",
              attrs: { icon: "warning", "icon-color": "warning" }
            },
            [
              _c("span", { staticClass: "text-normal" }, [
                _vm._v(
                  " Movimentações atualizadas junto ao CEI, histórico de 1 ano e meio de horizonte passado. Caso tenham mais movimentações antes desse período, adicione novos aportes/resgates. "
                )
              ])
            ]
          )
        : _vm._e(),
      _vm.showAlertFillPu
        ? _c(
            "BaseAlert",
            {
              staticClass: "my-2",
              attrs: { icon: "warning", "icon-color": "warning" }
            },
            [
              _c("span", { staticClass: "text-normal" }, [
                _vm._v(
                  " Você possui movimentações sem informação de preço unitário e quantidade, para conseguir calcular a rentabilidade é necessário preenchê-las. "
                )
              ])
            ]
          )
        : _vm._e(),
      _c("MovementsEventsTable", {
        attrs: {
          "sugestoes-por-movimentacao": _vm.sugestoesPorMovimentacao,
          mode: "movements",
          "hide-title": "",
          bus: _vm.busLeft,
          client: _vm.client,
          asset: _vm.asset,
          "movement-items": _vm.movements,
          "show-alert-fill-pu": _vm.showAlertFillPu,
          "id-asset-alert-fill-pu": _vm.asset.id
        },
        on: {
          "revisar-sugestoes": function($event) {
            return _vm.$emit("revisar-sugestoes", $event)
          },
          "remove-movimentacao": function($event) {
            return _vm.$emit("remove-movimentacao", $event)
          },
          "open-movimentacoes": function($event) {
            return _vm.$emit("open-movimentacoes", $event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }